import axios from 'axios';
import Config from '../config/config';

const defineEnv = Config;
const axiosInstance = axios.create({
  baseURL: defineEnv.cms_services.BASE_URL,
});

export default axiosInstance;
